export default function AssetMultiPickerController(
  $rootScope,
  $scope,
  equipmentRepository,
  $uibModalInstance,
  selectedAssets,
  singleSelect,
  requiresSelection,
  maxSelection,
  gettextCatalog,
  prefilter,
  pickerSettings,
  $state,
) {
  'ngInject';

  const addToDataLayer = (data) => window.dataLayer.push(data);

  //INIT LOCAL VARIABLES
  selectedAssets = selectedAssets ? selectedAssets : {};
  $scope._selectedAssets = { ...selectedAssets };
  $scope.showSelected = false;
  $scope.allowConfirmAll = true;
  $scope.unavailableAssets = {};
  $scope.confirmAll = false;
  $scope.isDirty = false;
  $scope.filters = {};
  $scope.currentPage = 1;
  $scope.pages = [];
  $scope.limit = 15;
  $scope.maxSize = 1;
  $scope.firstPage = 'First';
  $scope.lastPage = 'Last';
  $scope.select = {};
  $scope.select.all = false;
  $scope.infoMessage = '';
  $scope.selectLimit = parseInt(maxSelection);
  $scope.filterCount = 0;
  $scope.prevFilterCount = 0;
  $scope.singleMode = singleSelect;
  //Pagination
  $scope.currentPageSelectedAssets = [];
  $scope.bigCurrentPage = 1;
  $scope.itemsPerPage = 15;

  $scope.facets = null;
  $scope.intialAssets = { ...selectedAssets };
  $scope.canSelectAll = pickerSettings.canSelectAll && $scope.selectLimit !== 1;
  $scope.onFacetsChanged = function () {
    refresh();
  };

  $scope.getSelectedAssets = function () {
    let assets = [];
    for (let key in $scope._selectedAssets) {
      if ($scope._selectedAssets.hasOwnProperty(key)) {
        assets.push(key);
        $scope.size++;
      }
    }
    return assets;
  };

  $scope.pageChanged = function () {
    $scope.select.all = false;
    $scope.displayAssetsByPage();
  };

  $scope.showRequiredError = () =>
    requiresSelection && Object.keys($scope._selectedAssets).length === 0;

  $scope.displayAssetsByPage = function () {
    $scope.totalItems = $scope.numSelectedAssets();
    let begin = ($scope.bigCurrentPage - 1) * $scope.itemsPerPage;
    let end = begin + $scope.itemsPerPage;
    let arr = Object.keys($scope._selectedAssets).slice(begin, end);
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === 'undefined') {
        delete $scope._selectedAssets[arr[i]];
      }
    }
    return Object.keys($scope._selectedAssets).slice(begin, end);
  };

  let sinceForPage = function (page, limit) {
    return (page - 1) * limit;
  };

  let calculatePages = function () {
    $scope.pages = [];

    $scope.numPages = Math.ceil($scope.responseData.data.total / $scope.limit);
    //if the number of assets is lower then the limit, must be on the first page.
    if ($scope.responseData.data.cursor < $scope.limit) {
      $scope.currentPage = 1;
    }
    //always return a page higher if not equally divisible
    else $scope.currentPage = Math.ceil($scope.responseData.data.cursor / $scope.limit);

    let concurrentPages = 1;

    let cursor = $scope.currentPage - Math.ceil(concurrentPages / 2);

    if (cursor < 0) {
      cursor = 0;
    }

    $scope.showingLastPage = false;
    $scope.showingFirstPage = false;

    while ($scope.pages.length < concurrentPages) {
      if (cursor < $scope.numPages) {
        $scope.pages.push(cursor + 1);
        cursor++;

        if (cursor === 1) {
          $scope.showingFirstPage = true;
        }

        if (cursor === $scope.numPages) {
          $scope.showingLastPage = true;
        }
      } else {
        break;
      }
    }
  };

  const refresh = () => {
    $scope.select.all = false;
    $scope.infoMessage = '';

    if ($scope.loading) {
      $scope.isDirty = true;
      return;
    }
    $scope.loading = true;

    let options = {};
    options.limit = $scope.limit || 500;
    if ($scope.selectedPage) {
      options.since = sinceForPage($scope.selectedPage, $scope.limit);
    }

    equipmentRepository
      .getEquipmentSearch(
        $scope.queryString,
        options,
        $scope.filters,
        null,
        null,
        $scope.facets,
        $scope.tagFilters,
        null,
        null,
        prefilter,
      )
      .then(
        (response) => {
          $scope.responseData = response;

          $scope.assetsList = response.data.hits;

          calculatePages();
          $scope.select.all = $scope.isAllAssetSelected();
          $scope.error = null;
        },
        () => {
          $scope.error = gettextCatalog.getString('Error loading assets');
        },
      )
      .finally(() => {
        $scope.loading = false;
      });
  };

  let deselectAsset = (asset) => {
    if (!asset) return;
    if ($scope.unavailableAssets[asset.id]) return;
    asset.selected = false;

    delete $scope._selectedAssets[asset.id];
    $scope.select.all = false;
  };

  $scope.selectAll = function () {
    if (!$scope.showSelected) {
      if ($scope.select.all) {
        for (let i = 0; i < $scope.responseData.data.hits.length; i++) {
          if ($scope.selectLimit > 0 && $scope.numSelectedAssets() >= $scope.selectLimit) {
            $scope.infoMessage =
              gettextCatalog.getString('Only ') +
              maxSelection +
              gettextCatalog.getString(' asset(s) can be selected at this time.');
            break;
          }
          $scope._selectedAssets[$scope.responseData.data.hits[i].id] =
            $scope.responseData.data.hits[i];
        }
      } else {
        $scope.responseData.data.hits.forEach((value, index) => {
          deselectAsset($scope.responseData.data.hits[index]);
          $scope.infoMessage = '';
        });
      }
    } else {
      $scope._selectedAssets = {};
      $scope.infoMessage = '';

      if ($scope.select.all) {
        $scope._selectedAssets = {};
        $scope.assetsList.forEach((asset) => {
          $scope._selectedAssets[asset.id] = asset;
        });
      }
    }
  };

  $scope.isAllAssetSelected = () => {
    for (let i = 0; i < $scope.responseData.data.hits.length; i++) {
      let hasSelected = false;
      for (let key in $scope._selectedAssets) {
        if ($scope.responseData.data.hits[i].id === key) {
          hasSelected = true;
          break;
        }
      }
      if (!hasSelected) return false;
    }
    return true;
  };

  //WATCH FUNCTIONS
  $scope.$watch(
    'filters',
    (newValue, oldValue) => {
      $scope.currentPage = 1;
      if (newValue !== oldValue) {
        refresh();
      }
    },
    true,
  );

  //PUBLIC METHODS
  $scope.selectPage = function (page) {
    $scope.select.all = false;
    $scope.selectedPage = page;
    refresh();
  };

  $scope.submitQuery = function () {
    $scope.selectedPage = 1;
    refresh();

    addToDataLayer({
      event: 'assetPickerAssetSearching',
      data: {
        keyword: $scope.queryString,
        page: $state.current.name,
      },
    });
  };

  $rootScope.selectAsset = function (asset) {
    if (!asset) return;
    if ($scope.unavailableAssets[asset.id]) return;
    if (!singleSelect) {
      if (!$scope._selectedAssets[asset.id]) {
        if (parseInt(maxSelection) === 0) {
          $scope._selectedAssets[asset.id] = asset;
        } else if ($scope.numSelectedAssets() >= parseInt(maxSelection)) {
          $scope.infoMessage =
            gettextCatalog.getString('Only ') +
            maxSelection +
            gettextCatalog.getString(' asset(s) can be selected at this time.');
        } else {
          $scope._selectedAssets[asset.id] = asset;
          if ($scope.numSelectedAssets() == parseInt(maxSelection)) {
            $scope.infoMessage =
              gettextCatalog.getString('Only ') +
              maxSelection +
              gettextCatalog.getString(' asset(s) can be selected at this time.');
          }
        }
      } else {
        deselectAsset(asset);
        if ($scope.numSelectedAssets() < parseInt(maxSelection)) {
          $scope.infoMessage = '';
        }
      }
    } else {
      if (!$scope._selectedAssets[asset.id]) {
        $scope._selectedAssets = {};
        $scope._selectedAssets[asset.id] = asset;
      } else {
        delete $scope._selectedAssets[asset.id];
      }
    }

    $scope.select.all = $scope.isAllAssetSelected();
  };

  $scope.isDisabled = function (asset) {
    if (maxSelection === 0) {
      return false;
    }
    return (
      $scope.numSelectedAssets() >= parseInt(maxSelection) && !$scope._selectedAssets[asset.id]
    );
  };

  $scope.removeAsset = function (asset) {
    if (!asset) return;

    deselectAsset(asset);
  };

  $scope.numSelectedAssets = function () {
    return Object.keys($scope._selectedAssets).length || 0;
  };

  $scope.clearSelected = () => {
    $scope._selectedAssets = {};
  };

  $scope.toggleShowSelected = () => {
    $scope.showSelected = !$scope.showSelected;

    if ($scope.showSelected) {
      $scope.select.all = true;
      $scope.assetsList = Object.values($scope._selectedAssets);
      return;
    }
    $scope.select.all = $scope.isAllAssetSelected();
    $scope.assetsList = $scope.responseData.data.hits;
  };

  $scope.calculateRemovedAssets = (currentAssets, previousAssets) =>
    Object.keys(previousAssets).reduce((arr, assetId) => {
      if (!currentAssets.hasOwnProperty(assetId)) {
        arr.push(assetId);
      }
      return arr;
    }, []);

  $scope.calculateAddedAssets = (currentAssets, previousAssets) =>
    Object.keys(currentAssets).reduce((arr, assetId) => {
      if (!previousAssets.hasOwnProperty(assetId)) {
        arr.push(assetId);
      }
      return arr;
    }, []);

  //BUTTON EVENTS
  $scope.confirm = function () {
    $scope.submit = true;
    if (!$scope.confirmedAll && $scope.showRequiredError()) {
      return;
    }

    const added = $scope.calculateAddedAssets($scope._selectedAssets, $scope.intialAssets);

    const removed = $scope.calculateRemovedAssets($scope._selectedAssets, $scope.intialAssets);

    $uibModalInstance.close({
      result: $scope._selectedAssets,
      added,
      removed,
    });
  };

  // Confirm ALL assets from the query
  $scope.confirmAll = () => {
    $scope.confirmedAll = true;
    $scope.loading = true;

    let elasticSearchMaxResults = 9999;

    if ($scope.responseData.data.total > elasticSearchMaxResults) {
      $scope.infoMessage =
        'Note: We cannot currently export more than 10,000 units, we will fetch as many as we can. Try searching to narrow down the results.';
    }

    equipmentRepository
      .getAllEquipmentSearch(
        $scope.queryString,
        {},
        $scope.filters,
        null,
        null,
        $scope.facets,
        $scope.tagFilters,
        null,
        null,
        prefilter,
      )
      .then(
        (response) => {
          $scope.responseData = response;

          $scope._selectedAssets = response.data.hits.reduce((assets, asset) => {
            assets[asset.id] = asset;
            return assets;
          }, {});

          $scope.loading = false;
          $scope.confirm();
        },
        () => {
          $scope.infoMessage = '';
          $scope.error = gettextCatalog.getString('Error loading assets');
        },
      )
      .finally(() => {
        $scope.loading = false;
        $scope.infoMessage = '';
      });
  };

  $scope.cancel = () => {
    $uibModalInstance.close({
      result: selectedAssets,
      added: [],
      removed: [],
    });
  };

  $scope.$on('$locationChangeStart', (event) => {
    // Here you can take the control and call your own functions:

    $scope.cancel();
    event.preventDefault();
  });

  $scope.showFacets = () => {
    $scope.showingFacets = !$scope.showingFacets;
  };

  refresh();
}
